module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ack"
    }
  })]), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("I owe my gratitude to colleagues, friends, and students who have contributed their advice and insight to this project. Special recognition is extended to the IBM EMEA Legal Team, including Carl Belding, Dan Schenck, Fabio Moretti, Eva Salzmann, and Paloma Valor, for introducing me to the issues that this book addresses.")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("I would also like to thank the INSEAD and Harvard Alumni Groups, Michael Herlihy at International Chemical Corporation, and Victor Sonsino at the European Counsels Group, for providing ideas and perspective.")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("My appreciation goes to Dr. George Lakoff, Kathleen Frumkin, and Dr. Kyoko Inoue, for encouraging me to rethink English grammar for myself. I also want to thank Tanis Kmetyk, who is an ongoing source of editing insight and advice.")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("And finally, I extend my gratitude to Gina Panettieri at Talcott & Notch Literary Agency, and the top-flight crew at Career Press, for their cheerful suggestions, encouragement, and feedback.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d94e82c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bano_9781601638632_oeb_ack_r1.vue
// module id = 69
// module chunks = 0